import { basename } from 'lib/config';

export const withTo = (WrappedComponent) => {
  return (props) => {
    const { baseUrl, children, className, href, target, withCurrentQueryString, plainHref } = props;

    const url = plainHref || `${window.location.origin}${basename}${href}`;

    return <WrappedComponent {...props} href={url} />;
  };
};
